"use client";

import { MAIN_LAYOUT_CLASSES } from "@packages/design-system/constants";
import { usePathname } from "next/navigation";

export default function MainLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const pathname = usePathname();
  const isFullWidthPage = pathname === "/" || pathname?.startsWith("/admin");

  return (
    <main className={`grow ${isFullWidthPage ? "" : MAIN_LAYOUT_CLASSES}`}>
      {children}
    </main>
  );
}
